import React from 'react';
import { primaryTextColor } from '../../themes/index';

function DocDefault({ stroke = primaryTextColor, width = 16, height = 16, style, ...rest }) {
  return (
    <svg style={style} width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} >
      <rect x="2.5" y="1.5" width="13" height="15" rx="1.5" stroke={stroke} />
      <rect x="5" y="6" width="8" height="1" rx="0.5" fill={stroke} />
      <rect x="5" y="9" width="8" height="1" rx="0.5" fill={stroke} />
      <rect x="5" y="12" width="5" height="1" rx="0.5" fill={stroke} />
    </svg>

  );
}

export default DocDefault;
